import * as z from 'zod';

import { booleanMutationSchema } from '@/_schemas/generic';

import { inventorCategoryQuerySchema } from './inventory-category-query-schema';

export const inventorCategoryUpdateSchema = inventorCategoryQuerySchema
  .omit({
    icon: true,
    sku_label: true,
  })
  .extend({
    icon: z.array(z.number()).nullable(),
    sku_label: z.string(),
    track_serial_numbers: booleanMutationSchema(),
    track_stock_quantities: booleanMutationSchema(),
  });

export type InventorCategoryUpdateSchema = z.infer<typeof inventorCategoryUpdateSchema>;

export const inventorCategoryCreateSchema = inventorCategoryUpdateSchema.omit({
  id: true,
  icon: true,
});

export type InventorCategoryCreateSchema = z.infer<typeof inventorCategoryCreateSchema>;
